import * as React from "react";
import { useNavigate } from "react-router-dom";
import logger from "../../logger";
import {
  Avatar,
  Image,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuDivider,
  Text,
} from "@fluentui/react-components";
import { SignOut24Regular, ArrowSwap24Regular } from "@fluentui/react-icons";
import { useAuth } from "../auth/AuthContext";
import { useOrganization } from "../context/OrganizationContext";
import { useHeaderStyles } from "./Header.styles";

const Header = () => {
  const { user, logout } = useAuth();
  const { selectedOrganization } = useOrganization();
  const navigate = useNavigate();
  const styles = useHeaderStyles();

  const getUserInitials = () => {
    if (user?.name) {
      const names = user.name.split(" ");
      if (names.length >= 2) {
        return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
      }
      return user.name.substring(0, 2).toUpperCase();
    }
    if (user?.email) {
      return user.email.substring(0, 2).toUpperCase();
    }
    return "U";
  };

  const handleOrganizationSwitch = () => {
    navigate("/organization-list");
  };

  const handleProfile = () => {
    navigate("/my-profile");
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      logger.error("Logout error:", error);
    }
  };

  const displayName = user?.name || user?.email || "User";
  const activeOrgLabel = selectedOrganization
    ? selectedOrganization.isDR
      ? `${selectedOrganization.name} (DR)`
      : selectedOrganization.name
    : null;

  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <Image src="/assets/logo.png" alt="Logo" className={styles.logo} />
      </div>
      <div className={styles.headerRight}>
        {user && (
          <Menu>
            <MenuTrigger disableButtonEnhancement>
              <Avatar
                className={styles.avatar}
                name={displayName}
                initials={getUserInitials()}
                size={24}
                color="colorful"
              />
            </MenuTrigger>
            <MenuPopover className={styles.menuPopover}>
              <button
                type="button"
                className={styles.userInfo}
                onClick={handleProfile}
                aria-label="View profile"
              >
                <Avatar
                  className={styles.userInfoAvatar}
                  name={displayName}
                  initials={getUserInitials()}
                  size={48}
                  color="colorful"
                />
                <Text className={styles.userInfoName} as="span">
                  {displayName}
                </Text>
                {user.email && (
                  <Text className={styles.userInfoEmail} as="span">
                    {user.email}
                  </Text>
                )}
                {activeOrgLabel && (
                  <span className={styles.activeOrg}>
                    <Text className={styles.activeOrgLabel} as="span">
                      Active organization
                    </Text>
                    <Text className={styles.activeOrgName} as="span">
                      {activeOrgLabel}
                    </Text>
                  </span>
                )}
              </button>
              <MenuDivider />
              <MenuList>
                <MenuItem className={styles.menuItem} onClick={handleOrganizationSwitch}>
                  <ArrowSwap24Regular className={styles.menuIcon} />
                  <Text className={styles.menuItemLabel}>Change Organization</Text>
                </MenuItem>
                <MenuItem className={styles.menuItem} onClick={handleLogout}>
                  <SignOut24Regular className={styles.menuIcon} />
                  <Text className={styles.menuItemLabel}>Log out</Text>
                </MenuItem>
              </MenuList>
            </MenuPopover>
          </Menu>
        )}
      </div>
    </div>
  );
};

export default Header;
